import type { IncomeTaxDE } from 'types/incomeTax.types';
import type { ITax } from 'types/taxes.types';
import { TaxStatusEnum } from 'types/taxes.types';

const isTaxDone = (tax: ITax | IncomeTaxDE): boolean =>
  tax?.status === TaxStatusEnum.done;
export default isTaxDone;
